import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { SettingsButton } from './settingsbutton/main';
import { SettingsConfirm } from './SettingsConfirm/main';
import { SettingsUpdating } from './SettingsUpdating/main';
import './styles.scss';

export class Settings extends PureComponent {
  static propTypes = {
    forwardActivity: PropTypes.func,
    changeActivity: PropTypes.func,
    updateBundle: PropTypes.func,
    clearAll: PropTypes.func,
    clearAccount: PropTypes.func,
    clearDevice: PropTypes.func,
    decrementDeveloper: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);

    this.state = {
      confirm: false,
      updating: false,
      delDevice: {
        title: 'Edit time clock details',
        description: 'Are you sure you want to change the details of this timeclock?',
        confirm: this.props.clearDevice,
        cancel: () => this.hideModal('confirm'),
      },
      delAuth: {
        title: 'Reauthenticate',
        description: 'Are you sure you want to assign new manager details to this timeclock? ' +
        'Only an Admin should authenticate a device.',
        confirm: () => {
          if (window.NATIVE_INTERCOM) {
            window.intercom.reset();
          }
          this.props.clearAccount();
        },
        cancel: () => this.hideModal('confirm'),
      },
      forceUpdate: {
        cancel: () => this.hideModal('update'),
      },
      delAll: {
        title: 'Erase all data',
        description: 'Are you sure you want to erase all data on this timeclock?',
        confirm: () => {
          if (window.NATIVE_INTERCOM) {
            window.intercom.reset();
          }
          this.props.clearAll();
        },
        cancel: () => this.hideModal('confirm'),
      },
    };
  }

  componentDidMount() {
    this.props.setAndStartTimer(30000);
  }

  getInfo() {
    const build = process.env.LOG_VERSION;
    const { deviceId, nickname } = this.props.device;


    const leave = this.props.features.leave.value ? 'Enabled' : 'Disabled';
    const unavailability = this.props.features.unavailability.value ? 'Enabled' : 'Disabled';
    return (
      <div className="footer-text">
        <p>About</p>
        <p>Device Name: {nickname}</p>
        <p>Build: {build}. Device ID: {deviceId}.</p>
        <p>Leave: {leave}. Unavailability: {unavailability}.</p>
      </div>
    );
  }

  showModal(type, key) {
    this.setState({
      [type]: key,
    });
  }

  hideModal(type) {
    this.setState({
      [type]: false,
    });
  }

  render() {
    return (
      <div className='settings'>
        <ReactCSSTransitionGroup
          component='div'
          className='animationBlock'
          transitionName='fade'
          transitionAppear={false}
          transitionEnter
          transitionLeave
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {/* render confirm dialog? */
            this.state.confirm ?
              <SettingsConfirm {...this.state.confirm} key='settingsConfirm' /> : undefined
          }

          {/* render update dialog? */
            this.state.updating ?
              <SettingsUpdating {...this.state.updating} key='settingsUpdating' /> : undefined
          }
        </ReactCSSTransitionGroup>

        {/* Settings Title */}
        <div className="settings-title">
          <i className="fa fa-cog fa-2x" />
          <h3>Settings</h3>
        </div>

        <div className='flexbox'>
          <SettingsButton
            statsKey="edit_details"
            icontype="fa fa-pencil"
            name="Edit time clock details"
            description="Change the location and/or nickname of the time clock"
            onClick={() => this.showModal('confirm', this.state.delDevice)}
          />
          <SettingsButton
            statsKey="pending_clockins"
            icontype="fa fa-clock-o"
            name="Pending clock ins"
            description="Clock ins that have not been sent to Tanda"
            onClick={() => this.props.forwardActivity('pending')}
          />
          {/* TODO: add the on click function to the above component */}
          <SettingsButton
            statsKey="reauthenticate"
            icontype="fa fa-user"
            name="Reauthenticate"
            description="Assign a new manager account to the time clock"
            onClick={() => this.showModal('confirm', this.state.delAuth)}
          />
          <SettingsButton
            statsKey="features"
            icontype="fa fa-bolt"
            name="Feature management"
            description="Enable and disable features on the time clock"
            onClick={() => this.props.forwardActivity('features')}
          />
          <SettingsButton
            statsKey="check_updates"
            icontype="fa fa-arrow-circle-down"
            name="Check for updates"
            description="Check for the latest time clock software"
            onClick={() => this.showModal('updating', this.state.forceUpdate)}
          />
          <SettingsButton
            statsKey="erase_all"
            icontype="fa fa-trash"
            name="Erase all data"
            description="This will clear all of the time clock's data"
            onClick={() => this.showModal('confirm', this.state.delAll)}
          />
          {this.getInfo()}
        </div>
      </div>
    );
  }
}

Settings.propTypes = {
  device: PropTypes.shape({
    deviceId: PropTypes.number,
    nickname: PropTypes.string,
  }),
  features: PropTypes.shape({
    leave: PropTypes.shape({ value: PropTypes.bool }),
    unavailability: PropTypes.shape({ value: PropTypes.bool }),
  }),
  setAndStartTimer: PropTypes.func,
};

export default connect(state => ({
  device: state.get('device').toJS(),
}))(Settings);



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/settings/main.jsx